import styled from 'styled-components';

export const Body = styled.div`
  margin-top: 0;
  width: 100%;

  .login-bar {
    background-color: ${(props) => props.theme.$dark};

    a {
      color: ${(props) => props.theme.$white};
      text-decoration: underline;
    }
  }
`;

export const Container = styled.div.attrs({
  className: 'container',
})``;
